import React, { useState, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import moment from 'moment';
import Skeleton from 'react-loading-skeleton';

import Can from './../../Can';

import { useForm, Controller } from 'react-hook-form';
import * as yup from 'yup';

import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import esLocale from 'date-fns/locale/es';

import { makeStyles, withStyles } from '@material-ui/core/styles';
import { Input, TextField } from '@material-ui/core';

import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import { green, red } from '@material-ui/core/colors';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import CardContent from '@material-ui/core/CardContent';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Alert, AlertTitle } from '@material-ui/lab';
import Chip from '@material-ui/core/Chip';

import Button from '@material-ui/core/Button';
import SaveIcon from '@material-ui/icons/Save';
import DeleteIcon from '@material-ui/icons/Delete';
import ReplyIcon from '@material-ui/icons/Reply';

import UsersServices from './../../../services/api/users';
import ClientsService from './../../../services/api/clients';

import { GenericSelect } from './../../Common/Selects/Generic';
import { CompanySelect } from './../../Common/Selects/Company';

import { getSessionCookie } from './../../../services/session';
import { styles } from './styles';

const useStyles = makeStyles(styles);

const RedButton = withStyles((theme) => ({
  root: {
    color: theme.palette.getContrastText(red[500]),
    backgroundColor: red[500],
    '&:hover': {
      backgroundColor: red[700],
    },
  },
}))(Button);

const GreenButton = withStyles((theme) => ({
  root: {
    color: 'white', //theme.palette.getContrastText(green[500]),
    backgroundColor: green[500],
    '&:hover': {
      backgroundColor: green[700],
    },
  },
}))(Button);

const localeMap = {
  es: esLocale,
};

export const PassengersEdit = () => {
  const classes = useStyles();
  let history = useHistory();
  const [locale] = useState('es');
  let { passengerId } = useParams();

  const [isLoading, setIsLoading] = useState(true);
  const [requestError, setRequestError] = useState({
    error: false,
    errorDescription: null,
  });

  const [passenger, setPassenger] = useState({
    status: false,
    routes: [],
  });
  const [passengerRoutes, setPassengerRoutes] = useState([]);
  const [selectedRoutes, setSelectedRoutes] = useState([]);
  const [role, setRole] = useState('logged');
  const [open, setOpen] = useState(false);
  const [clients, setClients] = useState([]);

  //Handle Session Role
  useEffect(() => {
    let session = getSessionCookie();
    if (
      session !== undefined &&
      session.role !== undefined &&
      session.role !== null
    ) {
      setRole(session.role);
    }
  }, [role]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleStatusChange = (event) => {
    setValue('status', event.target.value);
    setPassenger({ ...passenger, status: event.target.value });
  };

  const handleExpirationDateChange = (date) => {
    setValue('expiration_date', date);
    setPassenger({ ...passenger, expiration_date: date });
  };

  let userSchema = yup.object().shape({
    name: yup.string().required(),
    address: yup.string(),
    email: yup.string(),
    phone1: yup.string(),
    expiration_date: yup.string().required(),
    status: yup.boolean().required(),
    clientId: yup.number().required(),
    companyId: yup.number(),
    routes: yup.array(),
  });

  const { handleSubmit, errors, control, setValue, reset, register } = useForm({
    validationSchema: userSchema,
  });

  const onSubmit = (data) => {
    setIsLoading(true);
    setRequestError({ error: false, errorDescription: null });

    //Request
    setTimeout(function () {
      //Request
      UsersServices.updatePassenger(passengerId, data)
        .then((response) => {
          if (response === null || !response.IsValid) {
            setForm(passenger);
            throw response.Message;
          }
          if (response.IsValid && response.Data !== undefined) {
            history.push(`/passengers/detail/${response.Data.UsuarioID}`);
          } else {
            throw response.Message;
          }
        })
        .catch((e) => {
          setRequestError({
            error: true,
            errorDescription: e.status ? e.Data.Message : e,
          });
          setIsLoading(false);
        });
    }, 500);
  };

  const handleDelete = () => {
    setTimeout(function () {
      //Request
      UsersServices.deletePassenger(passengerId)
        .then((response) => {
          if (response === null || !response.IsValid) {
            throw response.Message;
          }
          if (response.IsValid && response.Data !== undefined) {
            setOpen(false);
            history.push(`/passengers/`);
          } else {
            throw response.Message;
          }
        })
        .catch((e) => {
          setRequestError({
            error: true,
            errorDescription: e.status ? e.Data.Message : e,
          });
          setOpen(false);
          setIsLoading(false);
        });
    }, 1000);
  };

  const handleBackClick = () => {
    history.goBack();
  };

  useEffect(() => {
    setIsLoading(true);
    fetchPassenger();
  }, []);

  const fetchPassenger = async () => {
    UsersServices.getPassenger(passengerId)
      .then((response) => {
        if (response === null || !response.IsValid) {
          throw response.Message;
        }
        //Get Passenger
        if (response && response.Data !== undefined) {
          reset({
            name: response.Data.Nombre ? response.Data.Nombre : '',
            address: response.Data.Direccion ? response.Data.Direccion : '',
            email: response.Data.Email ? response.Data.Email : '',
            phone1: response.Data.Telefono1 ? response.Data.Telefono1 : '',
            expiration_date: moment(response.Data.FechaExpiracion).isValid()
              ? moment(response.Data.FechaExpiracion)
              : moment().add(1, 'M'),
            companyId: response.Data.ClienteID ? response.Data.ClienteID : '',
            clientId: response.Data.TipoUsuarioID
              ? response.Data.TipoUsuarioID
              : '',
            status: response.Data.EstaActivo ? response.Data.EstaActivo : '',
            username: response.Data.NombreUsuario,
            password: response.Data.Contraseña,
            created_at: response.Data.FechaCreacion,
          });

          setPassenger({
            name: response.Data.Nombre,
            address: response.Data.Direccion,
            email: response.Data.Email,
            phone1: response.Data.Telefono1,
            expiration_date: moment(response.Data.FechaExpiracion).isValid()
              ? moment(response.Data.FechaExpiracion)
              : moment().add(1, 'M'),
            companyId: response.Data.ClienteID ? response.Data.ClienteID : '',
            clientId: response.Data.TipoUsuarioID,
            status: response.Data.EstaActivo,
            username: response.Data.NombreUsuario,
            password: response.Data.Contraseña,
            created_at: response.Data.FechaCreacion,
          });
          
          let passengerRoutes = response.Data.rutasDisponiblesPorUsuario.map((_item) => {
            return _item.RutaID;
          });
          setSelectedRoutes(passengerRoutes);
          // console.log('response.Data.rutasDisponiblesPorUsuario :>> ', passengerRoutes);

          fetchPassengerRoutes(passengerRoutes);
          setIsLoading(false);
        } else if (response.Data === null) {
          history.push(`/passengers/`);
        }
      })
      .catch((e) => {
        setIsLoading(false);
      });
  };

  const fetchPassengerRoutes = async (passengerRoutes) => {
    UsersServices.getPassengerAvailableRoutes(passengerId)
      .then((response) => {
        if (response === null || !response.IsValid) {
          throw response.Message;
        }
        //Get Passenger
        if (response && response.Data !== undefined) {
          setPassengerRoutes(response.Data);
          
          setIsLoading(false);
        } else if (response.Data === null) {
          history.push(`/passengers/`);
        }
      })
      .catch((e) => {
        setIsLoading(false);
      });
  }

  const handleRouteChange = (event) => {
    setSelectedRoutes(event.target.value);
    setValue('routes', event.target.value);
    setPassenger({ ...passenger, routes: event.target.value });
  };

  const setForm = (data) => {
    setValue('name', data.Nombre);
    setValue('address', data.Direccion);
    setValue('email', data.Email);
    setValue('phone1', data.Telefono1);
    setValue(
      'expiration_date',
      moment(data.FechaExpiracion).isValid()
        ? moment(data.FechaExpiracion)
        : moment().add(1, 'M')
    );
    setValue('status', data.EstaActivo ? true : false);
  };

  const handleClientChange = (value) => {
    setValue('clientId', value);
    setPassenger({ ...passenger, clientId: value });
  };

  const handleCompanyChange = (value) => {
    setValue('companyId', value);
    setPassenger({ ...passenger, companyId: value });
  };

  //Handle Clientes Select Content
  useEffect(() => {
    let isCancelled = false;
    setTimeout(function () {
      let session = getSessionCookie();

      if (
        session !== undefined &&
        session.role !== undefined &&
        session.role !== null
      ) {
        setRole(session.role);
      }
      //Request
      if (passenger.companyId !== '' || session.role === 'client') {
        ClientsService.getList(
          passenger.companyId !== '' ? passenger.companyId : null
        )
          .then((response) => {
            if (response === null || !response.IsValid) {
              throw response.Message;
            }
            //
            if (response && response.Data !== undefined) {
              if (!isCancelled) {
                setClients(response.Data);
              }
            }
          })
          .catch((e) => {
            setIsLoading(false);
          });
      }
    }, 0);

    return () => {
      isCancelled = true;
    };
  }, [passenger.companyId]);

  return (
    <React.Fragment>
      <Card className={classes.card} style={{ background: '#f4f6f8' }}>
        <CardContent>
          <form
            className={classes.form}
            onSubmit={handleSubmit(onSubmit)}
            noValidate
          >
            {isLoading ? (
              <Skeleton count={5} height={50} />
            ) : (
              <React.Fragment>
                <Grid
                  container
                  spacing={2}
                  direction="row"
                  alignContent="center"
                  alignItems="flex-start"
                  justifyContent="space-between"
                >
                  <Grid item sm={6} xs={12}>
                    <input
                      type="hidden"
                      readOnly
                      name="username"
                      defaultValue={passenger.username}
                      ref={register}
                    />
                    <input
                      type="hidden"
                      readOnly
                      name="password"
                      defaultValue={passenger.password || ''}
                      ref={register}
                    />
                    <input
                      type="hidden"
                      readOnly
                      name="created_at"
                      defaultValue={passenger.created_at || ''}
                      ref={register}
                    />
                    <Controller
                      as={<TextField />}
                      control={control}
                      rules={{ name: true }}
                      name="name"
                      defaultValue={passenger.name || ''}
                      variant="outlined"
                      margin="normal"
                      fullWidth
                      required
                      id="name"
                      label="Nombre"
                      autoComplete="name"
                      autoFocus
                      error={errors.name ? true : false}
                    />

                    <Controller
                      as={<TextField />}
                      control={control}
                      rules={{ required: true }}
                      name="address"
                      defaultValue={passenger.address || ''}
                      variant="outlined"
                      margin="normal"
                      fullWidth
                      id="address"
                      label="Direccion"
                      autoComplete="address"
                      error={errors.address ? true : false}
                    />

                    <Controller
                      as={<TextField />}
                      control={control}
                      rules={{ required: true }}
                      name="phone1"
                      defaultValue={passenger.phone1}
                      variant="outlined"
                      margin="normal"
                      fullWidth
                      id="phone1"
                      label="Telefono 1"
                      autoComplete="phone1"
                      error={errors.phone1 ? true : false}
                    />

                    <Can
                      role={role}
                      perform="companies:read"
                      yes={() => (
                        <CompanySelect
                          parentCallback={handleCompanyChange}
                          companyId={passenger.companyId}
                          control={control}
                          error={errors.companyId ? true : false}
                        />
                      )}
                      no={() => ''}
                    />
                  </Grid>

                  <Grid item sm={6} xs={12}>
                    <Controller
                      as={<TextField />}
                      control={control}
                      rules={{ required: true }}
                      name="email"
                      defaultValue={passenger.email || ''}
                      variant="outlined"
                      margin="normal"
                      fullWidth
                      id="email"
                      label="Email"
                      autoComplete="email"
                      error={errors.email ? true : false}
                    />

                    <MuiPickersUtilsProvider
                      utils={DateFnsUtils}
                      locale={localeMap[locale]}
                    >
                      <Controller
                        as={
                          <KeyboardDatePicker
                            inputVariant="outlined"
                            margin="normal"
                            label="Fecha de Expiracion"
                            id="expiration_date"
                            name="expiration_date"
                            fullWidth
                            disablePast={true}
                            format={'dd/MM/yyyy'}
                            autoOk
                            value={passenger.expiration_date || ''}
                            onChange={handleExpirationDateChange}
                          />
                        }
                        control={control}
                        name="expiration_date"
                        required
                        error={errors.expiration_date ? true : false}
                      />
                    </MuiPickersUtilsProvider>

                    <Controller
                      as={
                        <FormControl
                          variant="outlined"
                          className={classes.select}
                        >
                          <InputLabel id="demo-simple-select-outlined-label">
                            Estado
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-outlined-label"
                            id="demo-simple-select-outlined"
                            autoWidth
                            defaultValue={passenger.status}
                            onChange={handleStatusChange}
                            label="Estado"
                          >
                            <MenuItem value={true}>Activo</MenuItem>
                            <MenuItem value={false}>Inactivo</MenuItem>
                          </Select>
                        </FormControl>
                      }
                      className={classes.select}
                      name="status"
                      control={control}
                    />

                    <Can
                      role={role}
                      perform="clients:read"
                      yes={() => (
                        <GenericSelect
                          className={classes.clientSelect}
                          parentCallback={handleClientChange}
                          parentExtraCallback={handleCompanyChange}
                          itemSelected={passenger.clientId}
                          itemKey="TipoUsuarioID"
                          label="Cliente"
                          itemValue="TipoUsuarioID"
                          itemText="Nombre"
                          inputName="clientId"
                          itemExtra="ClienteID"
                          items={clients.length > 0 ? clients : []}
                          control={control}
                          error={errors.clientId ? true : false}
                        />
                      )}
                      no={() => ''}
                    />
                    <Controller
                      as={
                        <FormControl variant="outlined" className={classes.select}>
                          <InputLabel id="demo-mutiple-chip-label-label">Rutas</InputLabel>
                            <Select
                              labelId="demo-mutiple-chip-label-label"
                              id="demo-mutiple-chip-label"
                              name="routes"
                              multiple
                              value={selectedRoutes || []}
                              onChange={handleRouteChange}
                              input={<Input id="select-multiple-chip" />}
                              renderValue={(selectedRoutes) => (
                                <div className={classes.chips}>
                                  {selectedRoutes.map((value) => {
                                    if(passengerRoutes.find( (_item) => _item.RutaID === value)){
                                      return <Chip key={value} label={passengerRoutes.find( (_item) => _item.RutaID === parseInt(value)).Nombre} className={classes.chip} />
                                    }
                                  })}
                                </div>
                              )}
                            >
                              {passengerRoutes.map( (_item) => {
                                return (
                                  <MenuItem key={_item.RutaID} value={_item.RutaID}>
                                    {_item.Nombre}
                                  </MenuItem>
                                )
                              })}
                          </Select>
                        </FormControl>
                      }
                      className={classes.select}
                      name="routes"
                      defaultValue={passenger.routes}
                      control={control}
                    />
                  </Grid>
                  <Grid item xs sm>
                    <Grid
                      container
                      spacing={1}
                      direction="row"
                      justifyContent="flex-end"
                    >
                      <Grid item>
                        <GreenButton
                          type="submit"
                          variant="contained"
                          color="primary"
                          size="large"
                          className={classes.button}
                          startIcon={<SaveIcon />}
                        >
                          Guardar Cambios
                        </GreenButton>
                      </Grid>
                      <Grid item>
                        <RedButton
                          variant="contained"
                          color="secondary"
                          size="large"
                          onClick={handleClickOpen}
                          className={classes.button}
                          startIcon={<DeleteIcon />}
                        >
                          Eliminar
                        </RedButton>
                      </Grid>
                      <Grid item>
                        <Button
                          onClick={handleBackClick}
                          variant="contained"
                          color="secondary"
                          size="large"
                          className={classes.button}
                          startIcon={<ReplyIcon />}
                        >
                          Cancelar
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                {requestError.error && (
                  <Grid
                    container
                    spacing={1}
                    direction="row"
                    justifyContent="flex-end"
                  >
                    <Grid item xs>
                      <Alert severity="error">
                        <AlertTitle>Algo salió mal</AlertTitle>
                        {requestError.errorDescription}
                      </Alert>
                    </Grid>
                  </Grid>
                )}
              </React.Fragment>
            )}
          </form>
        </CardContent>
      </Card>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {'Esta seguro que desea eliminar este Pasajero?'}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description"></DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancelar
          </Button>
          <Button onClick={handleDelete} color="primary" autoFocus>
            Eliminar
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};
